// Top-level paths served by the other zone (the `dashboard-next` app), not by
// this router. Mirror of the page paths `microfrontends.json` routes to it;
// the contract test in __tests__/zoneNavigation.test.js fails when they drift.
export const NEXT_ZONE_ROUTE_PREFIXES = ["/quick-answers", "/bot-maker"];

// True for a path the other zone serves: a prefix itself or anything nested
// under it, with or without a query string or hash. `/bot` and `/bot-makers`
// are not `/bot-maker`.
export const isNextZonePath = (path) => {
  const pathname = String(path || "").split(/[?#]/)[0];
  return NEXT_ZONE_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
};

// Goes to `path` from the legacy shell. Crossing zones is a full document
// load: this router has no route for the other zone's paths, so a
// `history.push` there leaves a blank screen until the user reloads.
export const navigateTo = (history, path) => {
  if (isNextZonePath(path)) {
    window.location.assign(path);
    return;
  }
  history.push(path);
};

// Safety net for any other in-app transition (a `history.push` or `replace`,
// a <Link>, a <Redirect>) that lands on a path of the other zone: the URL is
// already right, so a reload lets the platform serve the app that owns it.
// `history.listen` never fires for the initial location, so this cannot loop
// when this app is the one served at that path (a local dev server alone).
export const installNextZoneGuard = (history) =>
  history.listen((location) => {
    if (isNextZonePath(location.pathname)) window.location.reload();
  });
